// prettier-ignore
import { ProctorBucketAllocation, buildProctorBucketAllocation } from '../../../shared/proctor/ProctorBucketAllocation';
import { ProctorAllocation } from '../../../shared/native-modules/types/JSTProctorBridge';
import { applyProctorOverride } from '../../../shared/proctor/applyProctorOverride';
import { createContext, useCallback, useContext } from 'react';
import { getProctorAllocations } from '../../../shared/native-modules/tare/getProctorAllocations';
import { SerpProctorSpecification, SerpProctorSpecifications } from './SerpProctorSpecifications';
import { usePromise } from '../../../shared/util/usePromise';

const SerpProctorContext = createContext<Record<string, ProctorAllocation>>({});

export function useLoadSerpProctorAllocations() {
    const loadAllocations = useCallback(() => getProctorAllocations(SerpProctorSpecifications), []);
    return usePromise(loadAllocations);
}

export function useAllSerpProctorAllocations(): Record<string, ProctorAllocation> {
    return useContext(SerpProctorContext);
}

export function useSerpProctorAllocation<Specification extends SerpProctorSpecification>(
    test: Specification,
): ProctorBucketAllocation<Specification> {
    const allocations = useContext(SerpProctorContext);
    const allocation = allocations[test.name];
    return buildProctorBucketAllocation(test, allocation);
}

/**
 * Provides a React context for the proctor allocations used in this React Native provider
 */
export function SerpProctorProvider({
    children,
    allocations,
    override,
}: {
    children: React.ReactNode;
    allocations: Record<string, ProctorAllocation>;
    override?: Record<string, ProctorAllocation> | null | undefined;
}) {
    const mergedAllocations = applyProctorOverride(SerpProctorSpecifications, allocations, override);
    return <SerpProctorContext.Provider value={mergedAllocations}>{children}</SerpProctorContext.Provider>;
}